import "./Notifications.css";

import {
  MdNotificationsActive,
  MdShoppingBag,
  MdPayments,
  MdReviews,
  MdLocalOffer,
  MdInfo,
} from "react-icons/md";

function Notifications({ notifications = [] }) {

  const getIcon = (type) => {

    switch (type) {

      case "order":
        return <MdShoppingBag />;

      case "payment":
        return <MdPayments />;

      case "review":
        return <MdReviews />;

      case "offer":
        return <MdLocalOffer />;

      default:
        return <MdInfo />;
    }
  };

  const getColor = (type) => {

    switch (type) {

      case "order":
        return "#2563eb";

      case "payment":
        return "#16a34a";

      case "review":
        return "#f59e0b";

      case "offer":
        return "#9333ea";

      default:
        return "#6b7280";
    }
  };

  return (

    <div className="notifications-card">

      <div className="notification-header">

        <h2>

          <MdNotificationsActive />

          Notifications

        </h2>

      </div>

      {notifications.length === 0 ? (

        <div className="empty-notification">

          <p>No notifications available.</p>

        </div>

      ) : (

        notifications.map((item) => (

          <div
            className="notification-item"
            key={item._id || item.id}
          >

            <div
              className="notification-icon"
              style={{
                background: getColor(item.type),
              }}
            >
              {getIcon(item.type)}
            </div>

            <div className="notification-content">

              <h4>{item.title}</h4>

              <p>{item.message}</p>

              <small>
                {item.time || item.createdAt}
              </small>

            </div>

          </div>

        ))

      )}

    </div>

  );
}

export default Notifications;